// import userReducer from "components/welcome/ducks/reducer"

import userReducer from "@/components/welcome/ducks/slice"
import { combineReducers } from "@reduxjs/toolkit"

const welcomeReducer = combineReducers({
  user: userReducer,
})

export default welcomeReducer
